import React from 'react';
import ReactDOM from 'react-dom/client';
import RoutesUrls from './RoutesUrls';
import './root.css'
import './i18n'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RoutesUrls />
  </React.StrictMode>
);
